import { render, staticRenderFns } from "./properties-select-block.vue?vue&type=template&id=2afe2d7a"
import script from "./properties-select-block.vue?vue&type=script&lang=js"
export * from "./properties-select-block.vue?vue&type=script&lang=js"
import style0 from "./properties-select-block.vue?vue&type=style&index=0&id=2afe2d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports